import React from "react";

const Config = {
    Apk: {
        title: "APK PAUD/RA",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan || ''}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'APK PAUD/RA (%)',
                columns: [
                    {
                        Header: 'Laki-laki',
                        accessor: 'jp36_laki_laki',
                    },
                    {
                        Header: 'Perempuan',
                        accessor: 'jp36_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp36_jumlah',
                    },
                ]
            },
        ]
    },
    Apm: {
        title: "APM PAUD/RA",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 3-6',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp36_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp36_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp36_jumlah',
                    },
                ]
            },
        ]
    }
}

export default Config;